import { useFetchAllBanners } from '@entities/Banners'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { BannerCarousel } from '@widgets/banner-carousel'






export default function BannerGalleryBlock ({ block, payload }: BlockProps) {
  // payload.id может быть null - тогда загружаем все баннеры
  const typeId = payload?.id as string | null | undefined
  
  const { banners, loading } = useFetchAllBanners({
    typeId: typeId || null
  })

  // Если нет баннеров и не загружается - не показываем блок
  if (!loading && (!banners || banners.length === 0)) {
    return null
  }

  const isSmall = block.subtype === 'small'
  const isBig = block.subtype === 'big'

  return (
    <div className={styles.root__banner}>
      <BannerCarousel
        banners={banners}
        loading={loading}
        size={isSmall ? 'small' : isBig ? 'big' : 'big'}
      />
    </div>
  )
}
